const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Stat Block directive to display Total X and New X
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Analyze the resource defined to get Analyze data
 */
app.directive('simpleStats', ['Analyze', function (Analyze) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        for : '@',
        headline : '@',
        subset: '='
      },
      template: require('../../../templates/directives/overview/simple-stats.html'),
      controller: ['$scope', function ($scope) {
          var self = this;
          self.header = '';
          self.sub = '';
          self.down = false;
          self.up = true;
          self.percentage = 15;
          self.beforeLastMonthPercentage = 15;
          self.total = 100;
          self.totalUpToLastMonth = 100;
          self.totalUpToTheMonthBeforeLast = 100;
          self.lastMonthDiff = 0;
          self.monthBeforeLastDiff = 0;
          self.initialize = function () {
            self.header = $scope.headline;
            self.sub = $scope.for;
            var subresource = {subresource: self.sub.toLowerCase(), users: 'all'};
            if ($scope.subset) {
              subresource.user_list = $scope.subset;
            }
            switch (subresource.subresource) {
              case 'learning tracks':
                subresource.subresource = 'tracks';
                break;
              case 'signins':
              case 'sessions':
                subresource.subresource = 'authtokens';
                if (!$scope.action) {
                  subresource.action = 'signin';
                }
                break;
              case 'impressions':
                subresource.subresource = 'views';
                break;
            }
            Analyze.totals(subresource, function (data) {
              // Get total total-up-to-last-month and total-up-to-the-month-before-last
              self.total = data['total_' + subresource.subresource];
              self.totalUpToLastMonth = data['total_' + subresource.subresource + '_up_to_last_month'];
              self.totalUpToTheMonthBeforeLast = data['total_' + subresource.subresource + '_up_to_the_month_before_last'];
              // calculate the difference between the total and the total from last month to get the percentage later on
              self.lastMonthDiff = self.total - self.totalUpToLastMonth;
              // calculate the difference between the last month and the month before last to get the inclination (whether the arrow is up or down)
              // this is to determine the tendency (If July has more additions than June then the tendency is up)
              self.monthBeforeLastDiff = self.totalUpToLastMonth - self.totalUpToTheMonthBeforeLast;
              // calculate the percentage increase for this month
              self.percentage = self.totalUpToLastMonth === 0 ? 0 : Math.round((self.lastMonthDiff / self.totalUpToLastMonth) * 100);
              if(isNaN(self.percentage)) {
                self.percentage = 100;
              }
              // calculate tendency
              // calculate the percentage increase for the month before last
              self.beforeLastMonthPercentage = self.totalUpToTheMonthBeforeLast === 0 ? 0 : Math.round((self.monthBeforeLastDiff / self.totalUpToTheMonthBeforeLast) * 100);
              if(isNaN(self.beforeLastMonthPercentage)) {
                self.beforeLastMonthPercentage = 100;
              }
              //adjust tendency (Arrows) if needed
              if (self.beforeLastMonthPercentage > self.percentage) {
                self.up = false;
                self.down = true;
              }
            }, function (error) {
              console.log('Error getting totals:', error);
            });
          };

          if ($scope.subset) {
            if (typeof $scope.subset === 'string') {
              self.initialize();
            }
            $scope.$watch('subset', function(newVal, oldVal) {
              if (newVal !== oldVal) {
                self.initialize();
              }
            });
            return;
          }

          self.initialize();

        }],
      controllerAs: 'stats'
    };
  }]);